const translation = {
    confirm: 'Tem certeza?',
    common: { back: 'Voltar' },
    save: 'Salve',
    returnToGame: 'Tem certeza de que deseja voltar ao jogo?',
    yes: 'Sim',
    no: 'Não',
    login: {
        auth: 'Autorização',
        noAcc: 'Nenhuma conta',
        reg: 'Registro',
        mail: 'Entrar por e-mail',
        registration: 'Cadastro',
        agreement: 'Ao clicar no botão "Registrar", você confirma seu',
        agreementLink: 'consentimento para o processamento de dados pessoais.',
        submit: 'Registro',
        continue: 'Continuar',
        emailLabel: 'E-mail',
        passwordLabel: 'Senha',
        repeatPasswordLabel: 'Repita a senha',
        loginButton: 'Conecte-se',
        logout: 'Sair',
        invalidEmail: 'Formato de e-mail inválido',
        invalidFormatPassword: 'Formato de senha incorreto',
        forgotPassword: 'Esqueceu sua senha',
        passwordRecovery: 'Recuperação de senha',
        passwordRecoveryTitle: 'Enviaremos uma carta para o e-mail especificado',
        sendLetter: 'Enviar carta',
        userExists: 'Existe usuário com este e-mail',
        userNotExists: 'O usuário com este e-mail não existe',
        passwordResetToMail: 'As instruções para redefinir sua senha foram enviadas por e-mail.',
        passwordValidation: 'Deve conter de 8 a 20 letras ou números latinos',
        invalidPassword: 'Senha incorreta',
        sessionNotFound: 'Sessão não encontrada',
        mismatchPassword: 'Senha incorreta! Tente novamente',
        rememberPassword: 'Lembrou sua senha',
        restore: 'Restaurar',
        accExist: 'Ter uma conta',
        confirmationCode: 'Digite o código de confirmação enviado por e-mail',
        code: 'Código de confirmação',
        send: 'Enviar',
        confirmation: 'Confirme',
        resend: 'Reenviar',
        codeIsValid: 'O código é válido',
        codeNotValid: 'O código não é válido',
        newPassword: 'Insira uma nova senha',
        passwordUsedBefore: 'A senha já foi usada antes',
        passwordUpdatedSuccessfully: 'Senha atualizada com sucesso',
        enterEmail: 'Insira o seu endereço de email',
        enterPassword: 'Digite a senha',
        enterPasswordAgain: 'Digite sua senha novamente',
        enterAgreement: 'Confirme o seu consentimento para o tratamento de dados pessoais',
        notRobot: 'Prove que você não é um robô',
        deletionPersonalData: 'Para excluir dados pessoais, envie-nos uma mensagem por e-mail.',
    },
    profile: {
        edit: 'Editar Perfil',
        remove: 'Deletar conta',
        projectName: 'Nome do Projeto',
        editing: 'Editando seu perfil',
        name: 'Seu nome',
        lastName: 'Seu último Nome',
        inputPattern: 'De duas a dez letras',
        purchases: 'Compras estão ausentes',
        settings: 'Configurações',
        transactions: 'Transações',
        support: 'Suporte',
    },
    payment: {
        toPay: 'pagar',
        method: 'Forma de pagamento',
        pay: 'Pagar',
        purchases: 'Compras',
        paymentMethod: 'Forma de pagamento',
        debitCard: 'Cartão de débito',
        copy: 'ID de pagamento copiado!',
        cancellation: 'Tem certeza de que deseja cancelar o pagamento?',
        email: 'Email para receber um recibo',
        status: {
            none: 'Nenhum',
            pending: 'Pendente',
            paid: 'Pago',
            fail: 'Falha',
        },
        state: {
            progress: 'Pagamento em andamento',
            wait: 'Por favor, aguarde',
            paid: 'Pago',
            successful: 'Pagamento bem-sucedido',
            notPaid: 'Não pago',
            error: 'Erro',
            cancelled: 'Pagamento cancelado',
            cancel: 'Cancelar',
        },
    },
    games: {
        header: {
            buttonGuest: 'Convidado',
            buttonLogin: 'Conecte-se',
            buttonLogout: 'Sair',
        },
        buttonPlay: 'Brincadeira',
        buttonInDevelop: 'Em desenvolvimento',
    },
    support: {
        noPurchases: 'Você ainda não tem compras',
        contactSupport: 'Contatar o suporte',
        paymentId: 'ID de pagamento',
        userId: 'ID do usuário',
        requestReason: 'Motivo da solicitação',
        feedbackEmail: 'Email para retorno',
        dropNotCredited: 'Drop não creditado',
        other: 'Outro',
        success: 'Pedido aceito',
        successText: 'Recebemos o seu pedido e entraremos em contato por e-mail em breve',
        createTicket: 'Criar solicitação',
        ticketTitle: 'Meus Tickets',
        requestDescription: 'Por favor, descreva seu problema com o máximo de detalhes possível',
        requestTitleDescription: 'Digite um título',
        ticketTitlePlug: 'Solicitação de',
        errorMessageFormat: 'Formato de vídeo não suportado',
        errorMessageSize: 'O tamanho do arquivo excede o limite de',
        you: 'Você',
        subject: 'Assunto da solicitação',
        description: 'Descrição',
        descriptionEmptyWarning: 'Por favor, descreva o problema',
        conversationEnded: 'Conversa encerrada',
        system: 'Mensagem do sistema',
        messageDelivered: 'Mensagem recebida pelo sistema',
    },
    receipt: {
        generation: 'Gerando recibo',
        wait: 'Isso pode levar algum tempo, por favor, aguarde.'
    },
    blocked: {
        title: 'Acesso restrito',
        ip: 'O acesso ao site está restrito para usuários da sua região. Pedimos desculpas pelo transtorno e agradecemos a sua compreensão.'
    },
}

export default {
    translation,
}
